<template>
  <div :class="['search-bar', { 'config-mode': isConfigMode }]" class="d-flex align-items-center" :style="searchBarStyles">
    <div class="search-bar-container d-flex align-items-center">
      <input
        type="text"
        v-model="searchQuery"
        ref="searchBarInput"
        class="form-control"
        :placeholder="$t('search')"
        @input="onTypeSearch"
      />
    </div>
    <feather-icon
      icon="XIcon"
      class="cursor-pointer"
      size="16"
      @click="closeSearchBar"
    />
  </div>
</template>

<script>
import { debounce } from "lodash";
import { ref, onMounted, nextTick, computed } from "@vue/composition-api";

export default {
  props: {
    sidebarMinWidthReached: {
      type: Boolean,
      default: false,
    },
    searchBarWidth: {
      type: Number,
      default: 0,
    },
    isConfigMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["input", "toggle-search-bar", "reset-search-bar"],
  setup(props, { emit }) {
    const searchQuery = ref("");
    const searchBarInput = ref(null);

    const searchBarStyles = computed(() => {
      const styles = {};

      if (props.isConfigMode) {
        styles.width = '100%';
        styles.marginBottom = '1rem';
      } else if (props.searchBarWidth) {
        styles.width = `${props.searchBarWidth}px`;
      }

      return styles;
    });

    const focusInput = () => {
      nextTick(() => {
        if (searchBarInput.value) {
          searchBarInput.value.focus();
          searchBarInput.value.select();
        }
      });
    };

    const onTypeSearch = debounce(function (event) {
      if (event.target.value === "") {
        resetSearchBar();
      }
      emit("input", event.target.value);
    }, 800);

    const resetSearchBar = () => {
      emit("reset-search-bar");
      searchQuery.value = "";
    };

    const closeSearchBar = () => {
      resetSearchBar();
      emit("toggle-search-bar", false);
    };

    onMounted(() => {
      focusInput();
    });

    return {
      searchQuery,
      searchBarInput,
      closeSearchBar,
      onTypeSearch,
      focusInput,
      searchBarStyles,
    };
  },
};
</script>

<style lang="scss" scoped>
.search-bar {
  &.config-mode {
    width: 100%;
    margin-bottom: 1rem;

    .search-bar-container {
      flex: 1;
      margin-right: 0.5rem;
    }
  }

  .search-bar-container {
    flex: 1;
  }
}
</style>
